module.exports = __webpack_public_path__ + "img/parenting-exercises.94e6fd4a.svg";